import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingAnimationComponent } from './loading/loading.component';
import { LoadingService } from './loading-service.service';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoadingAnimationComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'bharatmandi-dashboard';
  loading$ :Observable<boolean>;
  constructor(public loadingService: LoadingService){
    

  }
  ngOnInit(){
      this.loading$ = this.loadingService.loading$;
  }

}
